import CRUDFactory from '@/services/CRUDFactory';

export default CRUDFactory('/faq-questions');
